(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diyprint-team-orders"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('team-carousel')) {
    class TeamCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;
        const scope = this.closest('.team-carousel-scope');
        this.prev = scope?.querySelector('[data-carousel-prev]');
        this.next = scope?.querySelector('[data-carousel-next]');
        this.dots = this.querySelector('[data-carousel-dots]');
        this.prev?.addEventListener('click', () => this.move(-1));
        this.next?.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => requestAnimationFrame(() => this.update()));
        this.resize = new ResizeObserver(() => this.build()); this.resize.observe(this.track); this.build();
      }
      disconnectedCallback() { this.resize?.disconnect(); }
      step() { return Math.max(1, this.track.clientWidth * .92); }
      move(direction) { this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' }); }
      build() {
        if (!this.dots) return this.update();
        const pages = Math.max(1, Math.ceil((this.track.scrollWidth - this.track.clientWidth) / this.step()) + 1);
        this.dots.replaceChildren(...Array.from({ length: pages }, (_, index) => { const dot = document.createElement('button'); dot.type = 'button'; dot.setAttribute('aria-label', `Go to slide ${index + 1} of ${pages}`); dot.addEventListener('click', () => this.track.scrollTo({ left: index * this.step(), behavior: 'smooth' })); return dot; })); this.update();
      }
      update() { const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth); if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2; if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2; const index = Math.min((this.dots?.children.length || 1) - 1, Math.round(this.track.scrollLeft / this.step())); [...(this.dots?.children || [])].forEach((dot, i) => { const active = i === index; dot.classList.toggle('is-active', active); if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); }); }
    }
    customElements.define('team-carousel', TeamCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
